import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { DSDispatchToFieldTeamRequestModel } from '../../Models/DSDispatchToField/DS-Dispatch-To-Field.model';
import { MisInventory } from '../../Models/MisInventory/mis-inventory';
import { MisInventoryService } from '../../Services/MisInventory/mis-inventory.service';

@Component({
  selector: 'app-mis-inventory',
  templateUrl: './mis-inventory.component.html',
  styleUrls: ['./mis-inventory.component.css']
})
export class MisInventoryComponent implements OnInit {
  public loader: string = "none";
  userName: string;
  roleId: string;
  PageNo:number = 1;  
  PageNo1:number = 1;  

  pageSetting: number = 10;
  totalPages:number;
  pageSetting1: number = 10;
  totalPages1:number;
  userId: string;
  public dsDispatchRequest: DSDispatchToFieldTeamRequestModel = new DSDispatchToFieldTeamRequestModel();
  public misInventory: MisInventory = new MisInventory();
  CurrentYear: string;
  calModel1: any;
  calModel2: any;
  totalItemCount: any; 
  totalItemCount1: any; 
  dsDispatchGrid: any;
  stockOut: any = [];
  stockIn: any = [];
  defaultValue: boolean = true;

  constructor(private toastr: ToastrService, private misInventoryService: MisInventoryService) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleId');
    this.userName = localStorage.getItem('dsu_userName');
  }

  ngOnInit() {
    this.CurrentYear = (new Date()).getFullYear().toString();
  }
  downloadLink(Path: string): void {
    this.loader = 'block';
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.dsDispatchRequest.fileUrl = Path;
    this.misInventoryService.DownloadFile(this.dsDispatchRequest).subscribe(
      success => {
        saveAs(success, this.userName + "_DispatchToField_" + formattedDate + ".xlsx");
        this.loader = 'none';
      },
      err => {
        this.toastr.error("Some problem occurred while downloading file.");
        this.loader = 'none';

      }
    );
  }

  DownloadExcelStockOut() {
    let isValid = true;
    this.loader = 'block';
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.loader = 'block';
    var datePipe = new DatePipe("en-US");
    this.calModel1 = datePipe.transform(this.calModel1, 'dd/MMM/yyyy');
    this.calModel2 = datePipe.transform(this.calModel2, 'dd/MMM/yyyy');

    this.misInventory.userID = localStorage.getItem('dsu_userId');

    let fromDate = new Date(this.calModel1);
    let toDate = new Date(this.calModel2);


    let formattedFromDate =  fromDate.getFullYear()+ "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
    let formattedToDate =  toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();

    if (formattedFromDate == null || formattedFromDate == '1970-1-1' || formattedToDate == null || formattedToDate == '1970-1-1') {
      this.toastr.error("Please enter From Date and To Date.");
      this.loader = 'none';
      isValid = false;
      return false;
    }
    if (fromDate > toDate) {
      this.toastr.error("To Date must be greater than From Date.");
      this.loader = 'none';
      return isValid = false;
    }
    if (isValid) {
      this.misInventory.toDate = formattedToDate;
      this.misInventory.fromDate = formattedFromDate;

      this.misInventoryService.GetExcelFileName(this.misInventory)
        .subscribe(success => {
          saveAs(success, this.userName + "_DispatchToSD_" + formattedDate + ".xlsx");
          this.loader = 'none';
        },
          err => {

            this.toastr.error("No data found");
            this.loader = 'none';
          });
    }
  }
  
  DownloadExcelStockIn() {
    let isValid = true;
    this.loader = 'block';
    let today = new Date();
    let month;
    if((today.getMonth() + 1)<10)
    {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
    }
    else
    {
          month =  (today.getMonth() + 1).toString().slice(-2);
    }
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.loader = 'block';
    var datePipe = new DatePipe("en-US");
    this.calModel1 = datePipe.transform(this.calModel1, 'dd/MMM/yyyy');
    this.calModel2 = datePipe.transform(this.calModel2, 'dd/MMM/yyyy');

    this.misInventory.userID = localStorage.getItem('dsu_userId');

    let fromDate = new Date(this.calModel1);
    let toDate = new Date(this.calModel2);


    let formattedFromDate =  fromDate.getFullYear()+ "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
    let formattedToDate =  toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();

    if (formattedFromDate == null || formattedFromDate == '1970-1-1' || formattedToDate == null || formattedToDate == '1970-1-1') {
      this.toastr.error("Please enter From Date and To Date.");
      this.loader = 'none';
      isValid = false;
      return false;
    }
    if (fromDate > toDate) {
      this.toastr.error("To Date must be greater than From Date.");
      this.loader = 'none';
      return isValid = false;
    }
    if (isValid) {
      this.misInventory.toDate = formattedToDate;
      this.misInventory.fromDate = formattedFromDate;

      this.misInventoryService.DownloadExcel(this.misInventory)
        .subscribe(success => {
          saveAs(success, this.userName + "_DispatchToSD_" + formattedDate + ".xlsx");
          this.loader = 'none';
        },
          err => {

            this.toastr.error("No data found");
            this.loader = 'none';
          });
    }
  }
  
  GetMisInventoryScreen() {

    this.loader = 'block';
    this.misInventory.userID = this.userId;
    var datePipe = new DatePipe("en-US");
    this.calModel1 = datePipe.transform(this.calModel1, 'dd/MMM/yyyy');
    this.calModel2 = datePipe.transform(this.calModel2, 'dd/MMM/yyyy');
    let isValid = true;
    let fromDate = new Date(this.calModel1);
    let toDate = new Date(this.calModel2);
    
    let formattedFromDate =  fromDate.getFullYear()+ "-" + (fromDate.getMonth() + 1) + "-" + fromDate.getDate();
    let formattedToDate =  toDate.getFullYear() + "-" + (toDate.getMonth() + 1) + "-" + toDate.getDate();

    if (formattedFromDate == null || formattedFromDate == '1970-1-1' || formattedToDate == null || formattedToDate == '1970-1-1') {
      this.toastr.error("Please enter From Date and To Date.");
      this.loader = 'none';
      isValid = false;
      return false;
    }
    if (fromDate > toDate) {
      this.toastr.error("To Date must be greater than From Date.");
      this.loader = 'none';
      return isValid = false;
    }
    if (isValid) {
      this.misInventory.toDate = formattedToDate;
      this.misInventory.fromDate = formattedFromDate;
      this.loader = 'block';
      this.misInventory.PageNo=this.PageNo;
      this.misInventory.PageNo1=this.PageNo1;

      this.misInventoryService.getStockoutScreenData(this.misInventory)
        .subscribe((response) => {
          if (response.status) {
            this.dsDispatchGrid = response.data;
            this.stockOut = this.dsDispatchGrid.table;
            this.stockIn = this.dsDispatchGrid.table1;
            this.defaultValue = false;
            this.loader = 'none';
            this.totalItemCount=response.data.table1[0].totaldata>0? response.data.table1[0].totaldata:0;
          this.totalPages = Math.ceil(this.totalItemCount / this.pageSetting); 
          this.totalItemCount1=response.data.table[0].totaldata1>0? response.data.table[0].totaldata1:0;
          this.totalPages1 = Math.ceil(this.totalItemCount1 / this.pageSetting1); 
          }
          else {
            this.toastr.error(response.message);
            this.loader = 'none';
          }

        }, error => {
          this.loader = 'none';
        });
    }
  }

  showCompaniesByPageNumber(page) {  
    if(page>this.totalPages || page<1){
      return;
    }
    this.PageNo = page;  
    this.GetMisInventoryScreen();
  }

  showCompaniesByPageNumber1(page) {  
    if(page>this.totalPages1 || page<1){
      return;
    }
    this.PageNo1 = page;  
    this.GetMisInventoryScreen();
  }  
  
  Reset() {
    this.defaultValue = true;
    this.calModel1 = null;
    this.calModel2 = null;
  }
  

}
